<template>
    <AtomBase class="atom-status" :class="{
        'info': level === 'info',
        'warning': level === 'warning',
        'error': level === 'error'
    }">
        <v-icon :icon="icon"></v-icon>
        <span>{{ status }}</span>
    </AtomBase>
</template>

<script>
import AtomBase from '@/components/common/atom/AtomBase.vue'

export default {
    name: 'AtomStatus',
    components: {
        AtomBase
    },
    props: {
        level: {
            type: String,
            default: 'warning',
            validator: (value) => ['info', 'warning', 'error'].includes(value)
        },
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        icon() {
            switch (this.level) {
                case 'info':
                    return 'fa-solid fa-circle-info'
                case 'warning':
                    return 'fa-solid fa-triangle-exclamation'
                case 'error':
                    return 'fa-solid fa-circle-xmark'
                default:
                    return 'fa-solid fa-triangle-exclamation'
            }
        }
    }
}
</script>

<style scoped>
.atom-status {
    height: 100%;
    max-width: unset;
    flex-grow: 1;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    color: rgb(var(--v-theme-invert));
    user-select: none;
}

.atom-status.info {
    background: linear-gradient(
        to bottom,
        rgba(var(--v-theme-color1), 0.3) 0%,
        rgba(var(--v-theme-color1), 0.1) 100%
    );
}

.atom-status.warning {
    background: linear-gradient(
        to bottom,
        rgba(var(--v-theme-warning), 0.5) 0%,
        rgba(var(--v-theme-warning), 0.3) 100%
    );
}

.atom-status.error {
    background: linear-gradient(
        to bottom,
        rgba(var(--v-theme-error), 0.5) 0%,
        rgba(var(--v-theme-error), 0.3) 100%
    );
}

.atom-status .v-icon {
    margin-left: 0.5rem;
    font-size: 1.2rem;
}

.atom-status span {
    font-size: 1rem;
}
</style>